export default __webpack_public_path__ + "static/media/poodlOne.2caae968.jpg";